import RouterManager from './router';
import FunctionManager, { FunctionType } from './function';
import VueRouter, { RouteConfig } from 'vue-router';
import { VueConstructor } from 'vue';

export default class ExtensionManager {
  public routerManager: RouterManager;
  public functionManager: FunctionManager;

  constructor(router: VueRouter, routeParent: VueConstructor) {
    this.routerManager = new RouterManager(router, routeParent);
    this.functionManager = new FunctionManager();
  }

  public bindRoutes(routes: RouteConfig[]) {
    this.routerManager.addRoutes(routes);
  }

  public bindFunctions(functions: any, type: FunctionType) {
    for (const key in functions) {
      if (functions.hasOwnProperty(key)) {
        this.functionManager.register(key, functions[key], type);
      }
    }
  }
}
